import { Navigate, type RouteObject } from "react-router";
import { AdminLayout, PackagesPage } from "./pages/AdminPages";
import { AppShell } from "./pages/AppShell";
import { AllowedAppsPage } from "./pages/AppPages";
import { ConnectPage } from "./pages/ConnectPage";
import { AuthGate } from "./pages/AuthPages";
import { AdventuresPage } from "./campaigns/AdventuresPage";
import { CampaignLayout } from "./campaigns/CampaignLayout";
import { CampaignListPage, NewCampaignPage } from "./campaigns/CampaignListPage";
import { EntriesPage, SearchPage, WorldPage } from "./campaigns/EntriesPage";
import { EntryPage } from "./campaigns/EntryPage";
import { CampaignHome } from "./campaigns/HomePage";
import { CampaignLogPage } from "./campaigns/LogPage";
import { PartyPage } from "./campaigns/PartyPage";
import { SessionsPage } from "./campaigns/SessionsPage";
import { CampaignSettingsPage } from "./campaigns/SettingsPage";
import { CharacterHome, CharacterLayout, SheetTabPage } from "./pages/CharacterLayout";
import { CharacterListPage } from "./pages/CharacterListPage";
import { MapsPage } from "./pages/MapsPage";
import { LedgerPage, LogPage, PlayPage, SettingsPage, ValuesPage } from "./pages/CharacterPages";
import { GroupPage } from "./pages/GroupPage";
import { NewCharacterPage } from "./pages/NewCharacterPage";
import { ProfilePage, UsersPage } from "./pages/UserPages";
import { WizardPage } from "./pages/WizardPage";

export const routes: RouteObject[] = [
  // Outside the shell: the consent page signs in itself and shows errors without an account.
  { path: "verbinden", element: <ConnectPage /> },
  {
    element: (
      <AuthGate>
        <AppShell />
      </AuthGate>
    ),
    children: [
      { index: true, element: <CharacterListPage /> },
      { path: "neu", element: <NewCharacterPage /> },
      { path: "gruppe", element: <GroupPage /> },
      { path: "benutzer", element: <Navigate to="/verwaltung/benutzer" replace /> },
      { path: "karten", element: <Navigate to="/verwaltung/karten" replace /> },
      {
        path: "verwaltung",
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="benutzer" replace /> },
          { path: "benutzer", element: <UsersPage /> },
          { path: "datenpakete", element: <PackagesPage /> },
          { path: "karten", element: <MapsPage /> },
          { path: "anwendungen", element: <AllowedAppsPage /> },
        ],
      },
      { path: "profil", element: <ProfilePage /> },
      { path: "kampagnen", element: <CampaignListPage /> },
      { path: "kampagnen/neu", element: <NewCampaignPage /> },
      {
        path: "k/:id",
        element: <CampaignLayout />,
        children: [
          { index: true, element: <CampaignHome /> },
          { path: "eintraege/:art?", element: <EntriesPage /> },
          { path: "e/:entryId", element: <EntryPage /> },
          { path: "suche", element: <SearchPage /> },
          { path: "gruppe", element: <PartyPage /> },
          { path: "welt", element: <WorldPage /> },
          { path: "abenteuer", element: <AdventuresPage /> },
          { path: "sitzungen", element: <SessionsPage /> },
          { path: "protokoll", element: <CampaignLogPage /> },
          { path: "einstellungen", element: <CampaignSettingsPage /> },
        ],
      },
      {
        path: "c/:id",
        element: <CharacterLayout />,
        children: [
          { index: true, element: <CharacterHome /> },
          { path: "assistent/:step?", element: <WizardPage /> },
          { path: "spiel", element: <PlayPage /> },
          { path: "bogen/:tab", element: <SheetTabPage /> },
          { path: "werte", element: <ValuesPage /> },
          { path: "protokoll", element: <LogPage /> },
          { path: "konto", element: <LedgerPage /> },
          { path: "einstellungen", element: <SettingsPage /> },
        ],
      },
    ],
  },
];
